import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '../../components/primitives';

const DataBuilderComplete = ({
  onSameLocation,
  onDifferentLocation,
  onViewFacility,
  onDiscoverEvents,
}) => {
  return (
    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ maxWidth: 480, textAlign: 'center' }}>
        <Typography variant="body1" sx={{ fontWeight: 600, mb: 2 }}>
          Your submission has been created and queued for review.
        </Typography>
        <Box component="ul" sx={{ textAlign: 'left', color: '#444444', pl: 3, mb: 4 }}>
          <li>New facilities, resources, and events are reviewed before appearing publicly in the "Find Events" search.</li>
          <li>You can still find your submission in an unverified state on the Facilities page.</li>
        </Box>
      </Box>

      <Typography variant="body2" sx={{ fontWeight: 600, mb: 2 }}>
        What would you like to do next?
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Button variant="outlined" onClick={onSameLocation} sx={{ py: 1.5 }}>
          Create another event at this location.
        </Button>
        <Button variant="outlined" onClick={onDifferentLocation} sx={{ py: 1.5 }}>
          Create a new event at a different location.
        </Button>
        <Button variant="outlined" onClick={onViewFacility} sx={{ py: 1.5 }}>
          Show me my event.
        </Button>
        <Button variant="outlined" onClick={onDiscoverEvents} sx={{ py: 1.5 }}>
          Discover more events.
        </Button>
      </Box>
    </Box>
  );
};

export default DataBuilderComplete;